import { useContext } from 'react'
import { PassContext } from "../../pass-context"
import PopupEditor from "../popup-editor"

import Field from './field'
import TrainItinerary from './auto-fields/train-itinerary.jsx'

const AppleBackFields = () => {

  try {
    const { template, passType, subType, variables } = useContext(PassContext)

    const fields = template.backFields

    return (
      <div className="inset">

        <TrainItinerary passType={passType} subType={subType} variables={variables} />
        <PopupEditor title="Detail Fields" path="backFields">
          <div className="editable">
            {fields?.map((field, idx) => <Field key={field.key} field={field} isLastField={idx === fields.length - 1} />)}
          </div>
        </PopupEditor>
      </div>
    )
  }
  catch (err) {
    throw err
  }
}

export default AppleBackFields